import React, { useState } from 'react';

/**
 * SUIVI DE STAGE — un bloc qu'on déplie (passe 3 bis, 2026-09-17)
 * ===============================================================
 * Demandé par Bertrand après la recette de la passe 3 : sur son dossier de test,
 * la section « ① Lien étudiant » déroulait **six** messages et poussait la fiche,
 * la convention et la visite hors de l'écran.
 *
 * ── CE QU'IL FAUT VOIR SANS OUVRIR ─────────────────────────────────────────
 * Le résumé n'est pas un titre : c'est la réponse à la question qu'on se pose en
 * regardant le dossier. Pour les envois, c'est « combien de fois l'a-t-on
 * relancé, et quand pour la dernière fois ». D'où un résumé qui porte des
 * NOMBRES et une DATE, pas un simple « Envois ».
 *
 * ── TOUJOURS REPLIÉ, MÊME POUR UNE SEULE LIGNE ─────────────────────────────
 * ⚠️ Tranché avec Bertrand le 2026-09-17. Afficher directement quand il n'y a
 * qu'un élément serait plus agréable d'un clic — mais cela ferait **deux
 * comportements pour un même bloc**, et une règle qui ne s'explique pas en une
 * phrase se paie plus cher que le clic qu'elle économise. C'est le même
 * arbitrage que celui qui a écarté le seuil du `mailto:` (écart E33).
 *
 * ── LE PLI NE SE SOUVIENT DE RIEN ──────────────────────────────────────────
 * ⚠️ Passer d'un dossier à l'autre doit **refermer** le bloc. L'appelant s'en
 * charge en posant une `key` qui change avec le dossier : le composant est alors
 * remonté, et son état repart à zéro. Sans cela, on ouvre un dossier et on
 * découvre un panneau déjà déroulé sans l'avoir demandé.
 *
 * ── ÉCRIT UNE FOIS, POUR TROIS USAGES ──────────────────────────────────────
 * L'historique du lot 3.3 et les documents déposés du lot 3.4 auront exactement
 * le même problème. Ce fichier existe pour qu'ils n'aient pas à le réinventer.
 */
function StageBlocRepliable({ resume, children, defautOuvert = false, titreBouton }) {
    const [ouvert, setOuvert] = useState(defautOuvert);


    return (
        <div className="stg-repli">
            {/* ⚠️ Un VRAI bouton, pas un `div` cliquable : il se prend au clavier,
                et `aria-expanded` annonce l'état à qui n'utilise pas la souris. */}
            <button
                type="button"
                className={'stg-repli-tete' + (ouvert ? ' ouvert' : '')}
                onClick={() => setOuvert((o) => !o)}
                aria-expanded={ouvert}
                title={titreBouton || (ouvert ? 'Replier' : 'Dérouler')}
            >
                <i className={'fa-solid ' + (ouvert ? 'fa-chevron-down' : 'fa-chevron-right')} />
                <span className="stg-repli-resume">{resume}</span>
            </button>
            {ouvert && <div className="stg-repli-corps">{children}</div>}
        </div>
    );
}

export default StageBlocRepliable;
